<style src="./Roles.scss" lang="scss"></style>
<template>
  <section class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-3">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form v-on:submit.prevent="createRegister">
              <h2>Cadastro da Permissão</h2>
              <div class="space-25"></div>

              <div class="form-group">
                <label>Nome da Permissão</label>
                <input
                  type="text"
                  placeholder="Operador Nível II"
                  class="form-control"
                  v-model="registerForm.form.name"
                />
              </div>

              <div class="form-group">
                <label>Clonar configurações</label>
                <select
                  class="form-control"
                  v-model="registerForm.form.roleBase"
                >
                  <option :value="false">
                    Novo
                  </option>
                  <option
                    v-for="(item, idx) in searchForm.form.roleList"
                    :key="idx"
                    :value="idx"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>

              <button
                class="btn btn-block btn-primary compose-mail"
                href="mail_compose.html"
                :disabled="registerForm.control.createButtonIsDisabled"
              >
                <i class="fa fa-save"></i>
                Criar Permissão
              </button>
            </form>
          </div>
        </div>
      </div>

      <div class="col-lg-9 animated fadeInRight">
        <div class="mail-box-header">
          <h2>Lista de Permissões</h2>

          <form>
            <div class="input-group">
              <select class="form-control" v-model="searchForm.form.roleId">
                <option
                  v-for="(item, idx) in searchForm.form.roleList"
                  :key="idx"
                  :value="idx"
                >
                  {{ item.name }}
                </option>
              </select>

              <div class="input-group-btn">
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  @click="updateRegister"
                >
                  <i class="fa fa-save"></i>
                  Salvar
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="mail-box">
          <table class="table table-hover table-mail">
            <thead class="table-head-roles">
              <tr>
                <th>Setor</th>
                <th @click="selectAllOfAction('show')">Show</th>
                <th @click="selectAllOfAction('create')">Criar</th>
                <th @click="selectAllOfAction('read')">Ler</th>
                <th @click="selectAllOfAction('update')">Editar</th>
                <th @click="selectAllOfAction('delete')">Remover</th>
              </tr>
            </thead>

            <tbody class="table-list-roles">
              <tr
                :class="{
                  'bg-info': listItem.group === listItem.sectorId,
                  'group-row': listItem.group === listItem.sectorId,
                }"
                v-for="(listItem, listIdx) in registerList.list"
                :key="listIdx"
                @click.prevent.stop="selectAllOfSector(listIdx)"
              >
                <td>{{ listItem.identity }}</td>
                <td>
                  <input
                    type="checkbox"
                    v-if="Object.hasOwn(listItem, 'show')"
                    v-model="listItem.show"
                    @click.stop
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    v-if="Object.hasOwn(listItem, 'create')"
                    v-model="listItem.create"
                    @click.stop
                  />
                </td>
                <td class="">
                  <input
                    type="checkbox"
                    v-if="Object.hasOwn(listItem, 'read')"
                    v-model="listItem.read"
                    @click.stop
                  />
                </td>
                <td class="">
                  <input
                    type="checkbox"
                    v-if="Object.hasOwn(listItem, 'update')"
                    v-model="listItem.update"
                    @click.stop
                  />
                </td>
                <td class="">
                  <input
                    type="checkbox"
                    v-if="Object.hasOwn(listItem, 'delete')"
                    v-model="listItem.delete"
                    @click.stop
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { toast } from '@/plugins/toast';
export default {
  name: 'Roles',
  data() {
    return {
      registerForm: {
        form: {
          name: '',
          roleBase: false,
        },
        control: {
          createButtonIsDisabled: false,
        },
      },
      searchForm: {
        form: {
          roleId: null,
          roleList: [],
        },
        control: {},
      },
      registerList: {
        list: [],
        control: {},
      },
    };
  },
  watch: {
    'searchForm.form.roleId'(roleIdx) {
      this.selectRole(roleIdx);
    },
  },
  mounted() {
    this.loadRoles();
    this.listRolesMap();
  },
  methods: {
    async listRolesMap() {
      const { Sectors = [] } = await this.$store.dispatch('ROLES/ListSectors');
      const sectorsList = Sectors.map(item => {
        const sectorMapped = {
          group: item.group,
          sectorId: item.sectorId,
          identity: item.identity,
        };

        if (item.actions.includes('SHOW')) {
          sectorMapped.show = false;
        }
        if (item.actions.includes('CREATE')) {
          sectorMapped.create = false;
        }
        if (item.actions.includes('READ')) {
          sectorMapped.read = false;
        }
        if (item.actions.includes('UPDATE')) {
          sectorMapped.update = false;
        }
        if (item.actions.includes('DELETE')) {
          sectorMapped.delete = false;
        }

        return sectorMapped;
      });
      this.registerList.list = sectorsList;
    },
    async loadRoles() {
      const list = await this.$store.dispatch('ROLES/ListRoles');
      this.searchForm.form.roleList = list;
    },
    selectRole(roleIdx) {
      const selectedPermissions = this.searchForm.form.roleList[roleIdx]
        .permissionsMapped;
      for (let item in this.registerList.list) {
        const perm = selectedPermissions[this.registerList.list[item].sectorId];
        if (Object.hasOwn(this.registerList.list[item], 'show')) {
          this.registerList.list[item].show =
            perm && perm.show ? perm.show : false;
        }
        if (Object.hasOwn(this.registerList.list[item], 'create')) {
          this.registerList.list[item].create =
            perm && perm.create ? perm.create : false;
        }
        if (Object.hasOwn(this.registerList.list[item], 'read')) {
          this.registerList.list[item].read =
            perm && perm.read ? perm.read : false;
        }
        if (Object.hasOwn(this.registerList.list[item], 'update')) {
          this.registerList.list[item].update =
            perm && perm.update ? perm.update : false;
        }
        if (Object.hasOwn(this.registerList.list[item], 'delete')) {
          this.registerList.list[item].delete =
            perm && perm.delete ? perm.delete : false;
        }
      }
    },
    async updateRegister() {
      const roleId = this.searchForm.form.roleList[this.searchForm.form.roleId]
        .id;
      const sectors = JSON.parse(JSON.stringify(this.registerList.list));

      let permissions = {};

      sectors.map((item, idx) => {
        const sectorId = sectors[idx].sectorId;
        permissions[sectorId] = [];

        delete item.group;
        delete item.identity;
        delete item.sectorId;

        for (let permission in item) {
          if (permission && item[permission]) {
            permissions[sectorId].push(permission.toUpperCase());
          }
        }
        return permissions;
      });

      const payload = {
        roleId,
        permissions,
      };

      await this.$store.dispatch('ROLES/UpdateRole', payload);
      await this.loadRoles();
      toast.success('Permissão modificada com sucesso!');
    },
    async createRegister() {
      if (this.registerForm.form.roleBase === false) {
        const sectors = JSON.parse(JSON.stringify(this.registerList.list));

        let permissions = {};

        sectors.map((item, idx) => {
          const sectorId = sectors[idx].sectorId;
          permissions[sectorId] = [];

          delete item.group;
          delete item.identity;
          delete item.sectorId;

          for (let permission in item) {
            if (permission && item[permission]) {
              permissions[sectorId].push();
            }
          }
          return permissions;
        });

        const payload = {
          name: this.registerForm.form.name,
          permissions,
        };

        await this.$store.dispatch('ROLES/CreateNewRole', payload);
      } else {
        const sectors = JSON.parse(JSON.stringify(this.registerList.list));
        const { permissionsMapped } = JSON.parse(
          JSON.stringify(
            this.searchForm.form.roleList[this.registerForm.form.roleBase],
          ),
        );
        let permissions = {};

        sectors.map((item, idx) => {
          const sectorId = sectors[idx].sectorId;
          permissions[sectorId] = [];

          delete item.group;
          delete item.identity;
          delete item.sectorId;

          for (let perm in item) {
            const isTrue = permissionsMapped[sectorId]
              ? permissionsMapped[sectorId][perm]
              : false;
            if (isTrue) {
              permissions[sectorId].push(perm.toUpperCase());
            }
          }

          return permissions;
        });

        const payload = {
          name: this.registerForm.form.name,
          permissions,
        };

        await this.$store.dispatch('ROLES/CreateNewRole', payload);
      }

      toast.success('Permissão criada com sucesso');
      this.loadRoles();
    },
    selectAllOfAction(actionType) {
      for (let action in this.registerList.list) {
        if (this.registerList.list[Object.hasOwn(action, actionType)]) {
          this.registerList.list[action][actionType] = !this.registerList.list[
            action
          ][actionType];
        }
      }
    },
    selectAllOfSector(sectorType) {
      for (let actions in this.registerList.list[sectorType]) {
        if (actions === 'sectorId' || actions === 'identity') {
          continue;
        }
        this.registerList.list[sectorType][actions] = !this.registerList.list[
          sectorType
        ][actions];
      }
    },
  },
};
</script>
